import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableSwitchOn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 18,
	viewBox: "0 0 36 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .910156,
			y: 1,
			width: 34,
			height: 16,
			rx: 2.5,
			fill: "white",
			stroke: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.69141,
			y: 2.71729,
			width: 13.6957,
			height: 12.9524,
			rx: 3,
			fill: "#40E098"
		})
	]
});
const ForwardRef = forwardRef(SvgTableSwitchOn);
export { ForwardRef as ReactComponent };
